import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import MuiListItemText from '@mui/material/ListItemText';
import type { ComponentProps } from 'react';

export const List = (props: ComponentProps<typeof MuiList>) => {
  return <MuiList {...props} />;
};

export const ListItem = (props: ComponentProps<typeof MuiListItem>) => {
  return <MuiListItem {...props} />;
};

export const ListItemIcon = (props: ComponentProps<typeof MuiListItemIcon>) => {
  return <MuiListItemIcon {...props} />;
};

export const ListItemText = (props: ComponentProps<typeof MuiListItemText>) => {
  return <MuiListItemText {...props} />;
};
